<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 13:40:55
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-14 11:22:32
 * @Description: 未审批下 操作按钮 审批
 -->
<template>
  <div class="list-table-action">
    <mk-button
      type="text"
      class="list-table-action__apply"
      @click="toExamineDetail"
    >
      查看
    </mk-button>
  </div>
</template>
<script>
export default {
  name: 'ListTableAction',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    },
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    // 跳转审批详情
    toExamineDetail () {
      let query = { ...this.scope.row, paperId: this.config.paperId }
      this.$router.push({
        path: '/business-school/examination-manage/paper-examine-approve/examine-approve-detail',
        query: query
      })
    }
  }
}
</script>
